import { get } from "http";
import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";


export function useTopicWordApi() {
  const callApi = useApiCall();

  const getTopics = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.TOPIC.TOPIC_LIST, data, onSuccess, onError);
  }

  const getWords = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORD.WORD_LIST, data, onSuccess, onError);
  }

  return {
    getTopics,
    getWords,
  };
}
